import { createSlice } from '@reduxjs/toolkit';
import { fetchKardexMovements, fetchKardexSummary } from './stockKardexThunks';
import { EMPTY_STOCK_TOTALS } from './stockConstants';
import { selectWarehouse } from '../warehouseContext/warehouseContextSlice';

const initialState = {
  /** The consolidated row of the product, or `null` when it has no balance. */
  product: null,
  totals: EMPTY_STOCK_TOTALS,
  summaryLoading: false,

  /** Current page of movements. */
  movements: [],
  totalCount: 0,
  loading: false,
  error: null,
  filters: {
    page: 1,
    rowsPerPage: 20,
  },
};

const stockKardexSlice = createSlice({
  name: 'stockKardex',
  initialState,
  reducers: {
    setKardexPage: (state, action) => {
      state.filters.page = action.payload;
    },
    setKardexRowsPerPage: (state, action) => {
      state.filters.rowsPerPage = action.payload;
      state.filters.page = 1;
    },
    /** Leaving the page: the next product must not open on this one's rows. */
    clearKardex: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchKardexSummary.pending, (state) => {
        state.summaryLoading = true;
      })
      .addCase(fetchKardexSummary.fulfilled, (state, action) => {
        state.summaryLoading = false;
        state.product = action.payload.product;
        state.totals = { ...EMPTY_STOCK_TOTALS, ...action.payload.totals };
      })
      // Not stored as `error`: the movements are the page, and they report
      // their own failure. A header without figures is not worth a red screen.
      .addCase(fetchKardexSummary.rejected, (state) => {
        state.summaryLoading = false;
      })

      .addCase(fetchKardexMovements.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchKardexMovements.fulfilled, (state, action) => {
        state.loading = false;
        state.movements = action.payload.results || [];
        state.totalCount = action.payload.count || 0;
      })
      .addCase(fetchKardexMovements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.movements = [];
        state.totalCount = 0;
      })

      // Another warehouse is another history: page 3 of this one may not exist.
      .addCase(selectWarehouse, (state) => {
        state.filters.page = 1;
      });
  },
});

export const { setKardexPage, setKardexRowsPerPage, clearKardex } = stockKardexSlice.actions;

export default stockKardexSlice.reducer;
